import { useTranslation } from '@ice-web-app/shared-hooks';
import { Button } from '@mui/material';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="mt-10">
      <h1 className="text-3xl font-bold text-center">{t('LABEL_NOT_FOUND', { label: t('PAGE') })}</h1>
      <div className="text-center mt-5">
        <Button variant="contained" color="primary" onClick={() => { window.history.back() }}>
          Previous Page
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
